import React from 'react';
import { namedOrCount } from '../lib/text';

const barButton = "px-3 py-1.5 rounded-lg font-semibold whitespace-nowrap disabled:cursor-not-allowed";
const neutral = `${barButton} border border-white/25 hover:bg-white/10 disabled:border-white/10 disabled:text-chrome-muted disabled:hover:bg-transparent`;
const primary = `${barButton} bg-linear-to-br from-zafiro-500 to-zafiro-600 hover:brightness-110 disabled:bg-none disabled:bg-chrome-raised disabled:text-chrome-muted disabled:hover:brightness-100`;

// La barra de las acciones de grupo: una sola, al pie de la ventana y fuera de las columnas. Sólo existe mientras hay
// algo tildado; dice cuántos hay en cada columna, para qué clientes, y ofrece las acciones de esa columna.
// `groups`: [{ column, count, clients, noClients, actions: [{ label, onClick, disabled, title, primary }] }].
export default function SelectionBar({ groups, onClear, clearTitle = 'Destildar todo, en las tres columnas' }) {
    if (groups.length === 0) return null;
    return (
        <div role="group" aria-label="Acciones sobre los updates seleccionados" className="flex-shrink-0 flex flex-wrap items-center gap-x-6 gap-y-2 min-h-14 px-6 py-2 bg-chrome text-white text-sm border-t border-white/10">
            {groups.map(({ column, count, clients, noClients, actions }) => (
                <div key={column} role="group" aria-label={column} className="min-w-0 flex flex-wrap items-center gap-2">
                    <span className="min-w-0 truncate">
                        <span className="text-chrome-muted">{column} ·</span> <strong>{count} {count === 1 ? 'seleccionado' : 'seleccionados'}</strong>{' '}
                        <span className="text-chrome-muted" title={clients.join(', ')}>→ {clients.length > 0 ? namedOrCount(clients) : noClients}</span>
                    </span>
                    {actions.map(action => (
                        <button key={action.label} type="button" disabled={action.disabled} title={action.title} onClick={action.onClick} className={action.primary ? primary : neutral}>{action.label}</button>
                    ))}
                </div>
            ))}
            <button type="button" onClick={onClear} title={clearTitle} className={`${neutral} ml-auto`}>Limpiar selección</button>
        </div>
    );
}
